import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import dataReducer from '../Reducers/data';
import filtersReducer from '../Reducers/filters';
import partsFiltersReducer from '../Reducers/partsFilters';
import laborProcessFiltersReducer from '../Reducers/laborProcessFilters';
import laborProcessFiltersDataReducer from '../Reducers/laborProcessFiltersData';
import partsFiltersDataReducer from '../Reducers/partsFlitersData';
import filtersDataReducer from '../Reducers/filtersData';
import loadingReducer from '../Reducers/loading';
import errorHandlerReducer from '../Reducers/errorHandler';
import loginHandlerReducer from '../Reducers/loginHandler';
import userInfoReducer from '../Reducers/userInfo';
import fileDownloadReducer from '../Reducers/download';
import thunk from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
    const store = createStore(
        combineReducers({
            data                    : dataReducer,
            filters                 : filtersReducer,
            partsFilters            : partsFiltersReducer,
            laborProcessFilters     : laborProcessFiltersReducer,
            filtersData             : filtersDataReducer,
            partsFiltersData        : partsFiltersDataReducer,
            laborProcessFiltersData : laborProcessFiltersDataReducer,
            userInfo                : userInfoReducer,
            loadingIndicator        : loadingReducer,
            errorHandler            : errorHandlerReducer,
            loginHandler            : loginHandlerReducer,
            fileDownload            : fileDownloadReducer
        }),
        composeEnhancers(applyMiddleware(thunk))
    );

    return store;
};



// WEBPACK FOOTER //
// ./src/Store/configureStore.js